module.exports = __webpack_public_path__ + "img/portraits_27_V.beb769c1.webp";